import * as R from 'ramda';
import { LevelGranulometry } from '../../LevelGranulometry';
import { CaseGranulometry } from '../../../cases/CaseGranulometry';
import { getCaseLevels } from '../../../cases/queries/levels/getCaseLevels';

export const isFoundationLevel = (
  caseGranulometry: CaseGranulometry,
  levelGranulometry: LevelGranulometry
): boolean => levelGranulometry.level === R.last(getCaseLevels(caseGranulometry))?.level;
